import {RouterModule, Routes } from '@angular/router';
import { PaPanelComponent } from './components/papanel/papanel.component';
import { PaCasesComponent } from './components/cases/cases.component';
import { PaOtherComponent } from './components/other/other.component';
import { PaFeedbackComponent } from './components/feedback/feedback.component';
import { PaSurveyComponent } from './components/survey/survey.component';
import { PaAppointmentComponent } from './components/appointment/appointment.component';
import { PaBookComponent } from './components/book/book.component';
import { PaProfileSettingsComponent } from './components/paprofile-settings/paprofile-settings.component';
import { AuthguardGuard } from '../../core/guards/authguard.guard';
import { PaStarRatingComponent } from './components/pa-star-rating/pa-star-rating.component';
import { NgModule } from '@angular/core';


export const PaRoutes: Routes = [
    {
    path: 'PAPanel',
    canActivate: [AuthguardGuard],
    data: { roles: ['PA'] },
        component: PaPanelComponent,
        children: [
          {
            path: 'cases',
            component: PaCasesComponent
          },
          {
            path: 'other',
            component: PaOtherComponent
          },
          {
            path: 'feedback',
            component: PaFeedbackComponent
          },
          {
            path: 'survey',
            component: PaSurveyComponent
          },
          {
            path: 'appointment',
            component: PaAppointmentComponent
          },
          {
            path: 'book',
            component: PaBookComponent
          },

          {
            path: 'profile',
            component: PaProfileSettingsComponent
          },
          {
            path: 'pa-star',
            component: PaStarRatingComponent
          },
          {
            path: '',
            redirectTo: 'appointment',
            pathMatch: 'full'
          }
        ]
      },
]

@NgModule({
    imports:[RouterModule.forChild(PaRoutes)],
    exports:[RouterModule],
})

export class PAROUTING{};
